export const Colors = {
	yellow: '#ffe802',
	blue: '#1f5eaf',
	white: '#ffffff',
	basicWhite: '#fafafa',
	black: '#000000',
	gray: '#777777',
	red: '#eb0505',
};
